import { TDateRange } from '../../api/types';
import React, { useState } from 'react';
import { Tab, Tabs } from '@patternfly/react-core';
import MyPeriodButtons from './MyPeriodButtons';
import { useApplication } from '../user/ApplicationProvider';

type DatePeriodHtmlProps = {
	updateSelectedDates: (selectedDateRange?: TDateRange) => (TDateRange | undefined)[];
	selectedRange: [TDateRange | undefined, TDateRange | undefined];
};

const DatePeriodHtml = (props: DatePeriodHtmlProps) => {
	const { updateSelectedDates, selectedRange } = props;
	const { periods, datePeriods } = useApplication();

	const [activeTabKey, setActiveTabKey] = useState(selectedRange[0]?.period ?? 3);

	const getDateRangesByPeriodId = (periodId: number) => {
		return datePeriods.filter((dp) => dp.period === periodId);
	};

	const isPeriodVisible = (periodId: number) => {
		return periods.some((p) => p.id === periodId && p.visible === true);
	};

	const handleTabSelect = (
		_event: React.MouseEvent<HTMLElement, MouseEvent>,
		tabIndex: string | number
	): void => {
		setActiveTabKey(Number(tabIndex));
		updateSelectedDates();
	};

	return (
		<div>
			<Tabs
				activeKey={activeTabKey}
				onSelect={handleTabSelect}
			>
				<Tab
					eventKey={0}
					title={'Period:'}
					isDisabled
				></Tab>

				{isPeriodVisible(5) && (
					<Tab
						eventKey={5}
						title={'Day'}
					>
						{activeTabKey === 5 && (
							<MyPeriodButtons
								datePeriods={getDateRangesByPeriodId(5)}
								selectedRange={selectedRange}
								updateSelectedDates={updateSelectedDates}
							/>
						)}
					</Tab>
				)}

				{isPeriodVisible(4) && (
					<Tab
						eventKey={4}
						title={'Week'}
					>
						{activeTabKey === 4 && (
							<MyPeriodButtons
								datePeriods={getDateRangesByPeriodId(4)}
								selectedRange={selectedRange}
								updateSelectedDates={updateSelectedDates}
							/>
						)}
					</Tab>
				)}

				{isPeriodVisible(3) && (
					<Tab
						eventKey={3}
						title={'Month'}
					>
						{activeTabKey === 3 && (
							<MyPeriodButtons
								datePeriods={getDateRangesByPeriodId(3)}
								selectedRange={selectedRange}
								updateSelectedDates={updateSelectedDates}
							/>
						)}
					</Tab>
				)}

				{isPeriodVisible(2) && (
					<Tab
						eventKey={2}
						title={'Quarter'}
					>
						{activeTabKey === 2 && (
							<MyPeriodButtons
								datePeriods={getDateRangesByPeriodId(2)}
								selectedRange={selectedRange}
								updateSelectedDates={updateSelectedDates}
							/>
						)}
					</Tab>
				)}

				{isPeriodVisible(1) && (
					<Tab
						eventKey={1}
						title={'Year'}
					>
						{activeTabKey === 1 && (
							<MyPeriodButtons
								datePeriods={getDateRangesByPeriodId(1)}
								selectedRange={selectedRange}
								updateSelectedDates={updateSelectedDates}
							/>
						)}
					</Tab>
				)}
			</Tabs>
			<br />
		</div>
	);
};

export default DatePeriodHtml;
